import React from 'react';

import { Dialog } from '@material-ui/core';
import Images from '../basics/Images';

export default () => (
  <Dialog
    open
    fullScreen
    BackdropProps={{ invisible: true }}
    transitionDuration={0}
    PaperProps={{
      style: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        display:         'flex',
        justifyContent:  'center',
        alignItems:      'center',
        width:           '100%',
        height:          '100vh',
        boxShadow:       'none',
      },
    }}
  >
    <img
      src={Images.Local.Spinner}
      style={{
        width: '100px',
      }}
      alt="Loading..."
    />
  </Dialog>
);
